export interface PathStep {
  id: number;
  message: string;
}

export interface OnboardingExperienceSteps {
  stepId: number;
  stepTitle: string;
  pathStep: PathStep[];
}

export const DEFAULT_ONBOARDING_STEPS: OnboardingExperienceSteps[] = [
  {
    stepId: 1,
    stepTitle: 'Movement',
    pathStep: [
      {
        id: 1,
        message: `"Hi, I’m Emily, Welcome to Scoot! I’m going to be giving you a brief orientation. Let’s go."`,
      },
      {
        id: 2,
        message: `"Scoot allows you to move freely around the environment. As you near other people, you will begin to hear their voices and be able to speak to them."`,
      },
      {
        id: 3,
        message: `"Give it a try! Use your mouse or arrow keys to come towards me."`,
      },
      {
        id: 4,
        message: `"When the white rings appear around us, that means we're in a group. When in a group you can speak and hear everyone clearly."`,
      },
      {
        id: 5,
        message: `"Groups can be up to 20 people in scoot. If the group is already too large, you’ll need to find a new one."`,
      },
      {
        id: 6,
        message: `"Great! Next, let’s orient you to the room."`,
      },
    ],
  },
  {
    stepId: 2,
    stepTitle: 'Navigation',
    pathStep: [
      {
        id: 1,
        message: `"With these controls, you can zoom in for a closer look or zoom out to see more of the room."`,
      },
      {
        id: 2,
        message: `"The mini map shows where people are. Once you're in the room, you can click to teleport to different areas."`,
      },
      {
        id: 3,
        message: `"By clicking on the room selector, you can navigate from room to room within the scootaverse."`,
      },
    ],
  },
  {
    stepId: 3,
    stepTitle: 'Smart Badging',
    pathStep: [
      {
        id: 1,
        message: `"You're never strangers in Scoot, thanks to Smart Badging. Click my name tag to take a look at my Smart Badge."`,
      },
      {
        id: 2,
        message: `"Here you can learn more about me, and do so much more like teleport to my location, or favorite me to easily find me or follow up after the meeting."`,
      },
      {
        id: 3,
        message: `"Now, let’s get your Smart Badge set up!"`,
      },
      {
        id: 4,
        message: `"Here you’ll see a preview of what your Smart Badge will look like in the room."`,
      },
    ],
  },
  {
    stepId: 4,
    stepTitle: 'State Magic',
    pathStep: [
      {
        id: 1,
        message: '"Your badge is looking good! Now, let’s talk about Stage Magic."',
      },
      {
        id: 2,
        message: '"Now, let’s talk about Stage Magic."',
      },
      {
        id: 3,
        message:
          '"Stage Magic provides a more engaging presentation experience with a variety of audience modes, gallery sorting, reactions, and more."',
      },
    ],
  },
];
